
interface ButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export default function Button({ 
  children, 
  onClick, 
  variant = 'primary', 
  size = 'md',
  className = '' 
}: ButtonProps) {
  const baseClasses = 'whitespace-nowrap cursor-pointer transition-all duration-300 font-medium focus:outline-none focus:ring-2 focus:ring-offset-2';
  
  const variantClasses = {
    primary: 'bg-[#663333] text-white hover:bg-[#553333] focus:ring-[#663333] focus:ring-offset-white',
    secondary: 'bg-[#cc9966] text-white hover:bg-[#bb8855] focus:ring-[#cc9966] focus:ring-offset-white',
    outline: 'border-2 border-[#cc9966] text-[#cc9966] hover:bg-[#cc9966] hover:text-white focus:ring-[#cc9966] focus:ring-offset-white'
  };
  
  const sizeClasses = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  
  return (
    <button
      onClick={onClick}
      className={`${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${className}`}
    >
      {children}
    </button>
  );
}
